import React from "react";
import { Link } from "react-router-dom";

export const About = () => {
  return (
    <main style={{ maxWidth: 760, margin: "96px auto 40px", padding: "0 20px" }}>
      <h1>Stop deciding. Start your next task.</h1>
      <p>
        Rundoit is a personal focus tool for moments when a task list feels
        harder than the work itself. Add the things you need to do, choose the
        focus mode that fits your day, and work with one clear next action.
      </p>
      <h2>Three simple ways to begin</h2>
      <p>
        Random Mode picks one task when you feel stuck. Start Mode guides you
        through the list with 25-minute focus sessions. Flow Mode gives you an
        open-ended timer for deeper work.
      </p>
      <p>
        Your account also includes starter templates, calendar planning,
        completed-task history, and standard ICS calendar export. Nothing is
        presented as magic—the goal is simply to make starting feel lighter.
      </p>
      <Link to="/demo">Try the interactive demo</Link>
    </main>
  );
};
